import React from 'react';
import { motion } from 'framer-motion';
import './TrustedPartners.css';
import { FiAward } from "react-icons/fi";
const clientslogos = [

  'assets/images/govtoftelangana.png',
  'assets/images/govtofrajasthan.png',
  'assets/images/cubimg.png',
  'assets/images/govtofassam.png',
  'assets/images/npci logo.png',
  'assets/images/isuimg.png',
  'assets/images/omniwareimg.png',
];

const logos = [
  'assets/images/image 1319.png',
  'assets/images/image 1320.png',
  'assets/images/image 1321.png',
  'assets/images/image 1322.png',
  'assets/images/image 1323.png',
  'assets/images/image 1324.png',
];
const certificates = [
  'assets/image (18).png',
  'assets/image (20).png',
  'assets/image (19).png',

];
const TrustedPartners = () => {
  return (
    <>
      {/* Animated Client Logos */}
      <section className="trusted-section">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.2,
              },
            },
          }}
        >
          <motion.h2
            className="trusted-heading"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          >
            Our Clients & Technical Partners
          </motion.h2>

          <div className="trusted-static">
            {clientslogos.map((logo, index) => (
              <motion.div
                className="trusted-logo"
                key={index}
                variants={{
                  hidden: { opacity: 0, y: 20, scale: 0.95 },
                  visible: { opacity: 1, y: 0, scale: 1 },
                }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
              >
                <img src={`/${logo}`} alt={`Partner ${index + 1}`} />
              </motion.div>
            ))}
          </div>
        </motion.div>
      </section>

      {/* Continuous Scrolling Partner Slider (unchanged) */}
      <section className="trusted-section">
        {/* <h2 className="trusted-heading">Technical Partners</h2> */}
        <div className="trusted-slider">
          <div className="trusted-track">
            {[...logos, ...logos].map((logo, index) => (
              <div key={index} className="trusted-logo">
                <img src={logo} alt={`Partner Logo ${index + 1}`} />
              </div>
            ))}

          </div>
        </div>


      </section>
      {/* --- NEW: Certificates Section (Inline Styles) --- */}
      <section style={{ padding: '30px 20px', backgroundColor: '#ffffff', textAlign: 'center' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '40px' }}>
            {/* <FiAward style={{ color: '#00b884', fontSize: '24px' }} /> */}
            <h2
              className="trusted-heading"
              style={{
                color: '#0f172a',
                margin: 0
              }}
            >
              Compliance & Certifications
            </h2>
          </div>

          <div
            className="certificates-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '30px',
              alignItems: 'center'
            }}
          >
            {certificates.map((cert, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.05 }}
                style={{
                  padding: '10px',
                  // backgroundColor: '#f8fafc',
                  // borderRadius: '16px',
                  // border: '1px solid #e2e8f0',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  // boxShadow: '0 4px 6px rgba(0,0,0,0.02)'
                }}
              >
                <img
                  src={`/${cert}`}
                  alt={`Certificate ${index + 1}`}
                  style={{ maxWidth: '100%', height: 'auto', maxHeight: '120px', objectFit: 'contain' }}
                />
              </motion.div>
            ))}
          </div>


        </div>
      </section>
    </>
  );
};

export default TrustedPartners;
